import React from 'react';
import clsx from 'clsx';
import { Table } from 'semantic-ui-react';
import { collectionUrl } from '@/constants/urls';
import {
  columnCreatedOn,
  columnDescription,
  columnNameLink,
  columnMultiSelect,
  columnTools,
  columnCollectionDatasetLastAdded,
  columnCollectionDatasetCount,
  hasColumn,
} from '@/constants/fields';
import SimpleCell from '@/components/table/SimpleCell';
import NameDescriptionRow from '@/components/table/NameDescriptionRow';
import CollectionTools from '../containers/CollectionTools';

const CollectionRow = ({
  category,
  collection,
  onCheckBoxClick,
  upward,
  className,
  columns = [
    columnMultiSelect,
    columnNameLink,
    columnDescription,
    columnCreatedOn,
    columnCollectionDatasetLastAdded,
    columnCollectionDatasetCount,
    columnTools,
  ],
}) => (
  <NameDescriptionRow
    className={clsx('aridhia-collection-row', className)}
    columns={columns}
    entity="collection"
    description={collection.description}
    href={collectionUrl(collection)}
    name={collection.name}
    selected={collection.selected}
    onSelect={() => onCheckBoxClick(collection.code)}
  >
    {hasColumn(columns, columnCreatedOn) && (<SimpleCell content={collection.createdOn} />)}
    {hasColumn(columns, columnCollectionDatasetLastAdded) && (<SimpleCell content={collection.lastDatasetAddedOn} />)}
    {hasColumn(columns, columnCollectionDatasetCount) && (<SimpleCell content={collection.totalDatasets} />)}
    {hasColumn(columns, columnTools) && (
      <Table.Cell collapsing>
        <CollectionTools
          url={collectionUrl(collection, '#')}
          upward={upward}
          category={category}
          collection={collection}
        />
      </Table.Cell>
    )}
  </NameDescriptionRow>
);

export default CollectionRow;
